// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// *** IntersectionObserver ***

// const elements = document.querySelectorAll(".msdw-animate");

// function check(entries) {
//   entries.map((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("msdw-animated");
//       observer.unobserve(entry.target);
//     }
//   });
// }

// const observer = new IntersectionObserver(check);

// elements.forEach((elem) => observer.observe(elem));


// *** requestAnimationFrame ***

// const scroll = window.requestAnimationFrame;

// function showOnScroll() {
//   const elems = document.querySelectorAll('.msdw-animate');

//   elems.forEach((el) => {
//     const elPosition = el.getBoundingClientRect().top
//     const elScreen = window.innerHeight / .9

//     if (elPosition < elScreen) {
//       el.classList.add('msdw-animated')
//     }
//   });

//   scroll(showOnScroll);
// }

// showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliderForestWrapper = document.querySelector('#sliderForest .swiper-wrapper');

let swiper= Swiper;
let init = false;

function swiperMode() {
  let mobile = window.matchMedia('(min-width: 0px) and (max-width: 899px)');
  let desktop = window.matchMedia('(min-width: 900px)');

  if (mobile.matches) {
    if (!init) {
      init = true;
      swiper = new Swiper('#sliderForest', {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev",
        },
      });
    }
    sliderForestWrapper.classList.remove('jws-grid-container', 'jws-grid-container-gutter', 'jwsdw-flexGrid');
  }

  else if (desktop.matches) {
    if (init) {
      init = false;
      swiper.destroy(true, true);
    }
    sliderForestWrapper.classList.add('jws-grid-container', 'jws-grid-container-gutter', 'jwsdw-flexGrid');
  }
}

window.addEventListener('load', function () {
  swiperMode();
});

window.addEventListener('resize', function () {
  swiperMode();
});


const sliderOutdoors = new Swiper('#sliderOutdoors', {
  slidesPerView: 1,
  spaceBetween: 10,
  freeMode: true,
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 2.5,
    },
    1480: {
      slidesPerView: 3,
    },
  },
});


//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------
const sliderSlot = document.getElementById('msdwSlidetSlot');
const catLandingMiddle = document.getElementById('cat-landing-middle');
catLandingMiddle && sliderSlot.appendChild(catLandingMiddle);